import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import CommonDialog from "../../CommonDialog/CommonDialog";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";
import AppIconsError from "../../AppIcons/AppIconsError";
import { BoxContainerStyled, BoxNotificationStyled, TypographyNotificationStyled } from "./OrderOfferNotification.style";

type OrderOfferNotificationProps = {
    open: boolean;
    onClose?: any;
    ponEmpty: boolean;
    ponBad: boolean;
    notAccepted: boolean;
    shipToAddressEmpty: boolean;
    deliveryDate:boolean;
    deliveryDateBad:boolean;
    isOffer:boolean;
};

export const OrderOfferNotification = (props: OrderOfferNotificationProps) => {
    

    const [open, setOpen] = useState(props.open);

    useEffect(() => {
        setOpen(props.open);
    }, [props.open]);

   
    const handleClose = (
    ) => {
        setOpen(false);
        if (props.onClose) props.onClose(true);
    };
    const { t } = useTranslation();
    const label_pon_bad= props.isOffer ?  t("offer.pon_not_valid")  : t("order.pon_not_valid")
    const label_pon_empty= props.isOffer ?  t("orderoffer.pon_offer_empty")  : t("orderoffer.pon_order_empty")
    return (
        <CommonDialog
            open={open}
            closeDialog={handleClose}
            dialogTitleLabel="alert.title.warning"
            useDenyBtn={false}
            confirmButtonText={"common.ok"}
            confirmButton={handleClose}
        >
            <BoxContainerStyled>
                {props.ponBad && (
                    <BoxNotificationStyled>
                        <AppIconsError color="warning" />
                        
                        <TypographyNotificationStyled>{label_pon_bad}</TypographyNotificationStyled>
                    </BoxNotificationStyled>
                )}
                {props.ponEmpty && (
                    <BoxNotificationStyled>
                        <AppIconsError color="warning" />
                        <TypographyNotificationStyled>
                            {label_pon_empty}
                        </TypographyNotificationStyled>
                    </BoxNotificationStyled>
                )}
                {props.shipToAddressEmpty && (
                    <BoxNotificationStyled>
                        <AppIconsError color="warning" />
                        <TypographyNotificationStyled>
                            {t("orderoffer.ship_to_address_empty")}
                        </TypographyNotificationStyled>
                    </BoxNotificationStyled>
                )}

                {props.deliveryDate && (
                    <BoxNotificationStyled>
                        <AppIconsError color="warning" />
                        <TypographyNotificationStyled>
                            {t("orderoffer.delivery_date_empty")}
                        </TypographyNotificationStyled>
                    </BoxNotificationStyled>
                )}

                {props.deliveryDateBad && (
                    <BoxNotificationStyled>
                        <AppIconsError color="warning" />
                        
                        <TypographyNotificationStyled>
                            {t("orderoffer.deliverydate_bad")}
                        </TypographyNotificationStyled>
                    </BoxNotificationStyled>
                )}

                {props.notAccepted && (
                    <BoxNotificationStyled>
                        <AppIconsError color="warning" />
                        <TypographyNotificationStyled>
                            {t("orderoffer.not_accepted")}
                        </TypographyNotificationStyled>
                    </BoxNotificationStyled>
                )}
            </BoxContainerStyled>
        </CommonDialog>
    );
};
